import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { ElementCategory, StandardType } from "@easy-email-pro-core/constants";
import {
  ElementDefinition,
  StandardHeroElement,
} from "@easy-email-pro-core/typings";
import React from "react";
import { Hero } from "@easy-email-pro-core/components/Elements";
import { cloneDeep } from "lodash";

import { Hero as SourceElement } from "../../basic/Hero";

const defaultHeroElement: StandardHeroElement = {
  type: "standard-hero",
  data: {},
  attributes: {
    "padding-top": "100px",
    "padding-bottom": "50px",
    "background-image-enabled": true,
    "background-color": "#c5900c",
    "background-position": "center center",
    mode: "fluid-height",
  },
  children: [
    {
      type: "standard-h1",
      data: {},
      attributes: {
        color: "#FFFFFF",
      },
      children: [
        {
          text: "We Serve Healthy & Delicious Foods",
        },
      ],
    },
    {
      type: "standard-paragraph",
      data: {},
      attributes: {
        color: "#FFFFFF",
      },
      children: [
        {
          text: "A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth.",
        },
      ],
    },
    {
      type: "standard-button",
      data: {
        content: "Button",
      },
      attributes: {
        "padding-top": "30px",
        "padding-bottom": "30px",
        "background-color": "#8b2a36",
      },
      children: [
        {
          text: "Get Your Order Here!",
        },
      ],
    },
  ],
};

const defaultData: ElementDefinition<StandardHeroElement>["defaultData"] =
  mergeBlock(SourceElement.defaultData, {
    attributes: {
      "background-image-enabled": true,
    },
    data: {},
  });

export const StandardHero = createBlock<StandardHeroElement>({
  get name() {
    return t("Hero");
  },
  defaultData,
  type: StandardType.STANDARD_HERO,
  create: (payload) => {
    return mergeBlock(defaultHeroElement, payload);
  },
  category: ElementCategory.HERO,
  render(params) {
    const { node } = params;

    const cloneAttributes = cloneDeep(node.attributes);

    const { ...attributes } = cloneAttributes;

    if (!attributes["background-image-enabled"]) {
      delete attributes["background-image-enabled"];

      delete attributes["background-url"];
      delete attributes["background-position"];
    }

    return (
      <Hero
        idx={params.idx}
        {...attributes}
        data={node.data}
        children={params.children || node.children}
      />
    );
  },
});
